import { Reducer } from 'redux'

import {
  UserDetails,
  AccountLimits,
  BankIconDetails,
  ActionTypes,
  MY_ACCOUNT_ACTIONS,
  FinancialInstituition,
  Wallet,
} from './types'

const initialState = {
  userDetails: {
    fullName: '',
    bankAccounts: [],
    blockchainAddresses: [],
    accountFullyVerified: true, // to prevent banners from popping up when loading
    kycInfoVerifying: false,
    kycRejectReason: {},
  },
  isUserDetailLoading: true,
  isAccountDetailLoading: true,
  accountLimits: {
    holdingRemaining: '',
    holdingMax: '',
    annualTransactionRemaining: '',
    annualTransactionMax: '',
  },
  bankIcons: [],
  hasDigitalGoodsAccounts: false,
  fiList: [],
  addressQuota: 0,
  wallets: null,
}

type State = {
  userDetails: UserDetails
  isUserDetailLoading: boolean
  isAccountDetailLoading: boolean
  accountLimits: AccountLimits
  bankIcons: BankIconDetails[]
  hasDigitalGoodsAccounts: boolean
  fiList: FinancialInstituition[]
  addressQuota: number
  wallets: Wallet[] | null
}

export const myAccount: Reducer<State, ActionTypes> = (state = initialState, action) => {
  switch (action.type) {
    case MY_ACCOUNT_ACTIONS.GET_USER_DETAILS: {
      return {
        ...state,
        userDetails: action.userDetails,
        hasDigitalGoodsAccounts: action.hasDigitalGoodsAccounts,
      }
    }

    case MY_ACCOUNT_ACTIONS.GET_STABLECOIN_DATA: {
      return {
        ...state,
        userDetails: {
          ...state.userDetails,
          blockchainAddresses: action.blockchainAddresses,
        },
        fiList: action.fiList,
        addressQuota: action.addressQuota,
      }
    }

    case MY_ACCOUNT_ACTIONS.GET_ACCOUNT_LIMITS: {
      return {
        ...state,
        accountLimits: action.accountLimits,
      }
    }

    case MY_ACCOUNT_ACTIONS.GET_BANK_ICONS: {
      return {
        ...state,
        bankIcons: action.bankIcons,
      }
    }

    case MY_ACCOUNT_ACTIONS.DELETE_BANK_ACCOUNTS: {
      return {
        ...state,
        userDetails: {
          ...state.userDetails,
          bankAccounts: action.bankAccounts,
        },
      }
    }

    // TODO: return altered state with deleted address
    case MY_ACCOUNT_ACTIONS.DELETE_BLOCKCHAIN_ADDRESS: {
      return {
        ...state,
        userDetails: {
          ...state.userDetails,
          blockchainAddresses: action.blockchainAddresses,
        },
        addressQuota: action.addressQuota,
      }
    }

    case MY_ACCOUNT_ACTIONS.GET_WALLETS: {
      return {
        ...state,
        wallets: action.wallets,
      }
    }

    case MY_ACCOUNT_ACTIONS.SET_IS_USER_DETAIL_LOADING: {
      return {
        ...state,
        isUserDetailLoading: action.isUserDetailLoading,
      }
    }

    case MY_ACCOUNT_ACTIONS.SET_IS_ACCOUNT_DETAIL_LOADING: {
      return {
        ...state,
        isAccountDetailLoading: action.isAccountDetailLoading,
      }
    }

    default:
      return state
  }
}
